import { useReduxSelector } from 'shared/hooks/useReduxSelector';
import { coworkingWorkplaceCountAsStringSelector } from 'shared/store/coworking/selectors/smart/coworkingWorkplaceCountAsStringSelector';

export function useCoworkingWorkplaceCountAsStringSelector(): string {
  return useReduxSelector<string>(coworkingWorkplaceCountAsStringSelector);
}
